import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import './Dropdown.css';

const Dropdown = ({ options, onSelect, placeholder, value }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [selectedOption, setSelectedOption] = useState(placeholder || 'Select an option');

    // Update selected option when the parent value changes
    useEffect(() => {
        if (value) {
            const selected = options.find(option => option.value === value);
            setSelectedOption(selected ? selected.label : placeholder);
        } else {
            setSelectedOption(placeholder || 'Select an option');
        }
    }, [value, options, placeholder]);

    const toggleDropdown = () => {
        setIsOpen(!isOpen);
    };

    const handleOptionClick = (option) => {
        setSelectedOption(option.label);
        setIsOpen(false);
        onSelect(option); 
    };

    return (
        <div className="dropdown">
            <div className="dropdown-toggle" onClick={toggleDropdown}>
                {selectedOption}
            </div>
            {isOpen && (
                <ul className="dropdown-menu">
                    {options.map((option) => (
                        <li key={option.value} onClick={() => handleOptionClick(option)}>
                            {option.label}
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
};

Dropdown.propTypes = {
    options: PropTypes.arrayOf(PropTypes.shape({
        value: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
    })).isRequired,
    onSelect: PropTypes.func.isRequired,
    placeholder: PropTypes.string,
    value: PropTypes.string, // Add a value prop to control the dropdown selection
};

export default Dropdown;
